import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AuthenticationService, Credentials } from '@bari/core';
import { Transaction } from '@bari/shared/model/transaction.model';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TransactionWalletService {

  private _user: Credentials;

  constructor(private http: HttpClient, private userService: AuthenticationService) {
    this._user = userService.credentials;

  }

  public getWalletTransactions(accountId: number, page?: string | number):
  Observable <{ next: boolean; transactions: Transaction[] }> {

    let url = `{api}/account/v1/transactions?accountId=${accountId}`;
    url += `&itemsPerPage=6`;

    if (page) {
      url += `&page=${page}`;
    }

    return this.http.get(url).pipe(map((data: any) => {
      data.items = data.items.map((transaction: any) => new Transaction().deserialize(transaction.item))
      return {
        next: data.hasNextPage,
        transactions: data.items
      };
    }
    )
    );

  }

}
